<template>
  <div class="water-supply-num">
    <custom-plane>
      <div class="water-content">
        <div class="water-num">
          <div class="num-item">
            <div class="title">正常数量</div>
            <div class="sub-title normal-color">
              {{ setNum(cusNumDataCount, "normal") }}
            </div>
          </div>
          <div class="num-item margin-lr">
            <div class="title">待机数量</div>
            <div class="sub-title">
              {{ setNum(cusNumDataCount, "standby") }}
            </div>
          </div>
          <div class="num-item">
            <div class="title">故障数量</div>
            <div class="sub-title error-color">
              {{ setNum(cusNumDataCount, "fault") }}
            </div>
          </div>
        </div>
        <!-- <div class="chart-content">
          <custom-charts :dataList="dataList"></custom-charts>
        </div> -->
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: {
        x: [],
        y: [],
      },
    };
  },
  props: {
    cusNumData: Object,
    pdjName: String,
  },
  watch: {
    cusNumData() {
      this.loadChartData();
    },
  },
  computed: {
    cusNumDataCount() {
      return this.cusNumData?.count;
    },
  },
  methods: {
    loadChartData() {
      for (let i = 1; i <= 24; i++) {
        this.dataList.x.push(i);
        // this.dataList.y.push(Math.random());
      }
    },
    setNum(val, status, num) {
      if (this.pdjName == "PDJ_A") {
        num = "05";
      } else {
        num = "06";
      }
      if (!val) {
        return "-";
      } else {
        return val[num][0][status];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.water-supply-num {
  width: 100%;
  height: 132px;
  margin-top: 20px;
  .water-content {
    padding-top: 20px;
    padding-left: 20px;
    .water-num {
      padding-left: 14px;
      display: flex;
      .margin-lr {
        margin: 0 42px;
      }
      .num-item {
        width: 88px;
        text-align: center;
        color: #ffffff;

        .title {
          font-weight: 500;
          font-size: 18px;
          line-height: 27px;
        }
        .sub-title {
          margin-top: 10px;
          font-family: "dina";
          font-weight: 500;
          font-size: 48px;
          line-height: 55px;
        }
      }
    }
    .chart-content {
      margin-top: 30px;
      width: 356px;
      height: 184px;
    }
  }
}
</style>
